import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import { LinkContainer } from "react-router-bootstrap";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Dropdown from "react-bootstrap/Dropdown";
import { useAuth } from "./../util/auth";

function NavbarCustom(props) {
  const auth = useAuth();

  return (
    <Navbar bg={props.bg} variant={props.variant} expand={props.expand}>
      <Container>
        <LinkContainer to="/">
          <Navbar.Brand>
            <img
              className="d-inline-block align-top"
              src={props.logo}
              alt="Logo"
              height="30"
            />
          </Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle aria-controls="navbar-nav" className="border-0" />
        <Navbar.Collapse id="navbar-nav" className="justify-content-end">
          <Nav>
            {true && (
              <NavDropdown id="dropdown" title="About Us" alignRight={true}>
                <LinkContainer to="/about">
                  <NavDropdown.Item active={false}>
                    <Dropdown.Divider />
                    Our Surprising Approach
                  </NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/about">
                  <NavDropdown.Item active={false}>
                    Our Values, Your Results
                  </NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/auth/signout">
                  <NavDropdown.Item
                    active={false}
                    onClick={(e) => {
                      e.preventDefault();
                      auth.signout();
                    }}
                  >
                    The Two Minute F.A.Q.
                  </NavDropdown.Item>
                </LinkContainer>
                <LinkContainer to="/talks">
                  <NavDropdown.Item active={false}>
                    Talks & Events
                  </NavDropdown.Item>
                </LinkContainer>
              </NavDropdown>
            )}

            {false}
          </Nav>
          <Nav>
            {(
                <NavDropdown id="dropdown" title="Developers" alignRight={true}>
                  <LinkContainer to="/contact-dev">
                    <NavDropdown.Item active={false}>
                      <Dropdown.Divider/>
                      Schedule a Call
                    </NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/upload-resume">
                    <NavDropdown.Item active={false}>
                      Upload Resume
                    </NavDropdown.Item>
                  </LinkContainer>
                        <LinkContainer to="/contact">
                    <NavDropdown.Item active={false}>
                      Submit Inquiry
                    </NavDropdown.Item>
                  </LinkContainer>
                </NavDropdown>
            )}
          </Nav>
          <Nav>
            {(
                <NavDropdown
                    id="dropdown"
                    title="Companies"
                    alignRight={true}
                >
                  <LinkContainer to="/contact">
                    <NavDropdown.Item active={false}>
                      <Dropdown.Divider/>
                      Schedule a Call
                    </NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/contact">
                    <NavDropdown.Item active={false}>
                      Submit Inquiry
                    </NavDropdown.Item>
                  </LinkContainer>
                </NavDropdown>
            )}

            {false}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarCustom;
